(function () {
  'use strict';

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.cwcInit === 'true') return;
    sectionEl.dataset.cwcInit = 'true';

    setupTabs(sectionEl);
    setupAddToCart(sectionEl);
  }

  /* === Tabs === */
  function setupTabs(sectionEl) {
    const tabs = Array.prototype.slice.call(sectionEl.querySelectorAll('.cwc_product-tabs__tab'));
    const panels = sectionEl.querySelectorAll('.cwc_product-tabs__panel');
    if (!tabs.length || !panels.length) return;

    function activate(index, focus) {
      tabs.forEach(function (tab, i) {
        const active = i === index;
        tab.classList.toggle('cwc_product-tabs__tab--active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function (panel, i) {
        const active = i === index;
        panel.classList.toggle('cwc_product-tabs__panel--active', active);
        panel.hidden = !active;
      });
      if (focus && tabs[index]) {
        tabs[index].focus();
        tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(index, false);
      });

      // Arrow-key navigation between tabs
      tab.addEventListener('keydown', function (event) {
        let next = null;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        activate(next, true);
      });
    });

    sectionEl._cwcActivateTab = activate;
  }

  /* === Add to Cart === */
  function setupAddToCart(sectionEl) {
    const forms = sectionEl.querySelectorAll('.cwc_product-tabs__card-form');
    const status = sectionEl.querySelector('.cwc_product-tabs__status');
    const addUrl = (sectionEl.dataset.cartAddUrl || '/cart/add') + '.js';
    const cartUrl = (sectionEl.dataset.cartUrl || '/cart') + '.js';

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        const button = form.querySelector('.cwc_product-tabs__card-button');
        const idInput = form.querySelector('input[name="id"]');
        if (!button || !idInput) return;

        const label = button.dataset.label || button.textContent;
        button.classList.add('cwc_product-tabs__card-button--loading');
        button.setAttribute('aria-busy', 'true');

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }] })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw new Error(data.description || data.message || 'Add to cart failed');
              return data;
            });
          })
          .then(function (added) {
            const item = added.items ? added.items[0] : added;
            return fetch(cartUrl, { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                refreshThemeCart(cart, item);
                showButtonState(button, label, 'Added ✓', 'cwc_product-tabs__card-button--added');
                if (status) status.textContent = (item && item.product_title ? item.product_title : 'Item') + ' added to cart';
              });
          })
          .catch(function (error) {
            showButtonState(button, label, 'Unavailable', null);
            if (status) status.textContent = error.message;
            document.dispatchEvent(new CustomEvent('cart:error', { detail: { errorMessage: error.message } }));
          })
          .finally(function () {
            button.classList.remove('cwc_product-tabs__card-button--loading');
            button.removeAttribute('aria-busy');
          });
      });
    });
  }

  function showButtonState(button, label, text, className) {
    button.textContent = text;
    if (className) button.classList.add(className);
    setTimeout(function () {
      button.textContent = label;
      if (className) button.classList.remove(className);
    }, 2000);
  }

  // Hand the updated cart to the theme so its count + quick cart drawer refresh and open
  function refreshThemeCart(cart, item) {
    if (window.theme) window.theme.cartData = cart;

    // Header cart count + free shipping bar listen on the theme's internal bus
    if (typeof window.emit === 'function') {
      window.emit('cart:updated', { cart: cart });
    }

    // Theme's quick cart refreshes and opens on this document event
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: item } }));
  }

  function initAllSections() {
    document.querySelectorAll('.cwc_product-tabs').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.cwc_product-tabs');
    if (section) initSection(section);
  });

  // Theme Editor: show the tab whose block is selected
  document.addEventListener('shopify:block:select', function (event) {
    const tab = event.target;
    if (!tab || !tab.classList.contains('cwc_product-tabs__tab')) return;
    const section = tab.closest('.cwc_product-tabs');
    if (section && section._cwcActivateTab) {
      section._cwcActivateTab(parseInt(tab.dataset.index, 10) || 0, false);
    }
  });
})();
